module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_15_schw_pomelo_sa.e1cdc3d5.png";